module.exports = __webpack_public_path__ + "img/48.a2db9cc7.png";